import house1 from "../assets/images/house1.jpg";
import house2 from "../assets/images/house2.jpg";
import large1 from "../assets/images/large1.jpg";
import gateResidence from "../assets/images/IMG-20240721-WA0055.jpg";
import laserScreen from "../assets/images/IMG-20240721-WA0032.jpg";
import residentialFence from "../assets/images/IMG-20240721-WA0059.jpg";
import laserGate from "../assets/images/IMG-20240721-WA0061.jpg";
import commercialFacade from "../assets/images/IMG-20240721-WA0077.jpg";
import wallArt from "../assets/images/IMG-20240721-WA0112.jpg";
import balustradeLanding from "../assets/images/IMG-20240721-WA0090.jpg";
import staircaseRailing from "../assets/images/IMG-20240721-WA0097.jpg";
import framedPanels from "../assets/images/IMG-20240721-WA0113.jpg";
import metalDecor from "../assets/images/IMG-20240721-WA0118.jpg";
import waterTankTower from "../assets/images/IMG-20240721-WA0093.jpg";
import mixedStructure from "../assets/images/IMG-20240721-WA0091.jpg";

export const companyInfo = {
  name: "Touchmark Limited",
  shortName: "Touchmark",
  email: "touchmark67@yahoo.com",
  phonePrimary: "08022226010",
  phoneSecondary: "07036530590",
  phonePrimaryIntl: "+234 802 222 6010",
  phoneSecondaryIntl: "+234 703 653 0590",
  whatsappLink: "https://wa.me/2348022226010",
  founded: "2001",
  rcNumber: "RC No. 332,580",
  serviceArea:
    "Abuja, Lagos, Enugu and project delivery for private and commercial clients across Nigeria.",
  officeAddresses: [
    "Abuja Office: 8C Biskra Street, Ibrahim Abacha Estate, Wuse Zone 4",
    "Workshop: ACO Lugbe, Abuja",
    "Lagos Office: 37 Godwin Okigbo Street, Masha, Surulere",
  ],
};

export const heroSlides = [
  {
    image: house2,
    eyebrow: "Architectural metalwork",
    title: "Premium gates, fencing and exterior metal details built to finish strong.",
    text: "Touchmark fabricates modern wrought iron, stainless steel and laser-cut installations for homes, estates, plazas and commercial properties.",
  },
  {
    image: laserScreen,
    eyebrow: "Decorative fabrication",
    title: "Custom patterns, clean welds and statement pieces that lift a property.",
    text: "From feature gates and stair balustrades to branded screens and wall art, every piece is shaped for function and visual impact.",
  },
  {
    image: waterTankTower,
    eyebrow: "Structural delivery",
    title: "Reliable steel support systems, towers and site-ready fabrication.",
    text: "We handle fabrication, finishing and installation with the workshop capability and site support needed for demanding builds.",
  },
];

export const companyStats = [
  { value: "Since 2001", label: "Registered and operating with long-term industry experience" },
  { value: "20+ years", label: "Senior welding, operations and project leadership expertise" },
  { value: "Nationwide", label: "Project reach from Abuja to Lagos, Enugu and beyond" },
  { value: "On-site capable", label: "Mobile bending tools and workshop-backed production" },
];

export const serviceGroups = [
  {
    title: "Residential and estate metalwork",
    description:
      "Drive gates, pedestrian gates, perimeter fencing, balcony rails, window grilles and compound features built for security and curb appeal.",
    bullets: ["Fence and gate fabrication", "Balustrades and handrails", "Window and door grilles"],
  },
  {
    title: "Decorative wrought iron and laser-cut work",
    description:
      "Statement screens, feature panels, ornamental details and branded decorative elements for interiors and exteriors.",
    bullets: ["Laser-cut screens", "Decor panels and wall art", "Metal ornaments and accents"],
  },
  {
    title: "Stainless steel and architectural finishes",
    description:
      "Contemporary stainless installations and clean-lined rails for modern homes, plazas, hotels and office developments.",
    bullets: ["Stainless rails", "Modern staircase details", "Low-maintenance finishes"],
  },
  {
    title: "Structural fabrication",
    description:
      "Steel trusses, support frames, tank towers, canopies, pergolas, awnings and site fabrication for larger property needs.",
    bullets: ["Ground and overhead tank structures", "Steel trusses", "Pergolas and car ports"],
  },
  {
    title: "Furniture and bespoke pieces",
    description:
      "Functional furniture frames and one-off decorative products that combine fabrication precision with a design-led look.",
    bullets: ["Custom furniture", "Feature sculptures", "Interior statement pieces"],
  },
  {
    title: "Project coordination support",
    description:
      "Through internal experience and partner relationships, Touchmark supports building construction delivery, finishing coordination and project management.",
    bullets: ["Project management", "Site supervision", "Partner-led construction support"],
  },
];

export const sectors = [
  "Private residences",
  "Luxury duplexes and estates",
  "Hotels and hospitality projects",
  "Shopping malls and plazas",
  "Office complexes",
  "Schools and institutions",
  "Factories and warehouses",
];

export const promisePoints = [
  {
    title: "Built around the actual site condition",
    text: "Projects are handled with workshop precision and the flexibility to adapt on-site when dimensions or installation details change.",
  },
  {
    title: "Design detail without losing durability",
    text: "The work balances visual appeal, structural integrity and finishes that hold up in everyday use.",
  },
  {
    title: "Experienced leadership",
    text: "The team combines business oversight, design sensibility, structural coordination and long-practice fabrication knowledge.",
  },
];

export const leadership = [
  {
    name: "Mr. Christopher Odumah",
    role: "Managing Director",
    bio: "Psychology graduate with an MBA and over 20 years of sales, marketing and business development experience, including extensive leadership in metal fabrication, wrought iron design and furniture delivery.",
  },
  {
    name: "Arch. Basil Odumah",
    role: "Executive Director, Operations",
    bio: "Architect with postgraduate training in architecture and urban design, plus more than 25 years in urban design, construction, interiors, landscaping and project management across large public and private developments.",
  },
  {
    name: "Barr. Anthony Odumah",
    role: "Executive Director, Administration",
    bio: "Legal and administrative lead with more than 15 years of professional experience in legal practice, property development and day-to-day business administration.",
  },
];

export const featuredProjects = [
  {
    title: "High-end residential fencing and frontage",
    location: "Private residential developments",
    summary:
      "Clean-lined fencing, feature gates and coordinated frontage metalwork designed to sharpen the architectural finish of premium homes.",
    image: house1,
  },
  {
    title: "Decorative laser-cut gate systems",
    location: "Modern homes and compounds",
    summary:
      "Laser-cut gate infills and detailed steel frames that create privacy, airflow and a strong first impression at the entrance.",
    image: laserGate,
  },
  {
    title: "Stair rails and internal balustrades",
    location: "Duplexes and interior spaces",
    summary:
      "Custom stair rails and landing guards fabricated to align with the geometry of each staircase and interior finish.",
    image: staircaseRailing,
  },
  {
    title: "Steel water tank support structure",
    location: "Residential and mixed-use sites",
    summary:
      "Fabricated steel support systems for water storage with practical access, bracing and installation-ready stability.",
    image: waterTankTower,
  },
  {
    title: "Decorative screens and wall features",
    location: "Interior and exterior design applications",
    summary:
      "Feature panels and ornamental metal pieces that turn fabrication into part of the design language of the space.",
    image: framedPanels,
  },
  {
    title: "Commercial and multi-unit building work",
    location: "Plazas, offices and larger compounds",
    summary:
      "Broader scope fabrication support for facades, rails, structural features and site coordination on bigger developments.",
    image: commercialFacade,
  },
];

export const projectHighlights = [
  "Fabrication and installation of metal handrail and staircase works at O'Neal Plaza, Jabi, Abuja.",
  "Fabrication and installation of window grilles and drive gates for a private residence in Yola.",
  "Partnership support on major building construction and coordinated finishing across residential and commercial jobs.",
];

export const galleryItems = [
  {
    title: "Luxury residence frontage",
    category: "Exterior metalwork",
    image: house1,
  },
  {
    title: "Modern compound fencing",
    category: "Exterior metalwork",
    image: house2,
  },
  {
    title: "Tank tower fabrication",
    category: "Structural steel",
    image: large1,
  },
  {
    title: "Decorative residential gate",
    category: "Gates and fencing",
    image: gateResidence,
  },
  {
    title: "Decorative metal feature panel",
    category: "Decorative metalwork",
    image: laserScreen,
  },
  {
    title: "Finished residential fence line",
    category: "Gates and fencing",
    image: residentialFence,
  },
  {
    title: "Laser-cut gate detail",
    category: "Gates and fencing",
    image: laserGate,
  },
  {
    title: "Exterior fabrication and facade structures",
    category: "Commercial projects",
    image: commercialFacade,
  },
  {
    title: "Wall-mounted tree art",
    category: "Decorative metalwork",
    image: wallArt,
  },
  {
    title: "Balustrade at landing edge",
    category: "Balustrades and rails",
    image: balustradeLanding,
  },
  {
    title: "Wrought iron staircase rail",
    category: "Balustrades and rails",
    image: staircaseRailing,
  },
  {
    title: "Framed laser-cut leaf panels",
    category: "Decorative metalwork",
    image: framedPanels,
  },
  {
    title: "Freestanding decorative pieces",
    category: "Decorative metalwork",
    image: metalDecor,
  },
  {
    title: "Overhead water tank tower",
    category: "Structural steel",
    image: waterTankTower,
  },
  {
    title: "Steel frame installation in progress",
    category: "Commercial projects",
    image: mixedStructure,
  },
];
